<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Datepicker } from '@Shelly/shelly-design-system';
	import type { ExecuteOnceAt } from 'src/types/TimeBasedConditionsUI';
	import TimePickerWrapper from '../../../../../../../../TimePicker/TimePickerWrapper.svelte';
	import { dateLabels, getMonthsOptions, startsWeekOnSun } from 'src/helpers/date_helper';

	export let value: ExecuteOnceAt;

	let date = new Date(value.date);
	const firstDayOfWeek = startsWeekOnSun() ? 0 : 1,
		defaultMonthsOptions = getMonthsOptions(),
		weekdays: any = dateLabels('days');
</script>

<Text class="mb-s" styleType="h2">
	{$format('select_type', {
		values: { type: $format('selection_date') },
	})}
</Text>

<Datepicker
	a11yProps={{
		iconButtonAriaLabel: $format('schedules_clear', { default: 'Clear' }),
		inputAriaLabel: $format('select_date_one_time', { default: 'Select date' }),
		toggleButtonAriaLabel: $format('toggle_calendar', { default: 'Toggle calendar' }),
	}}
	aria-label={$format('select_date_one_time', { default: 'Select date' })}
	class="mb-l"
	size="m"
	id="select-date-one-time"
	mode="single"
	value={[date]}
	{defaultMonthsOptions}
	options={{
		locale: {
			firstDayOfWeek,
			weekdays: {
				shorthand: weekdays,
				longhand: weekdays,
			},
		},
	}}
	on:change={(e) => {
		// console.log(e);
		date = e.detail[1];
		value.date = e.detail[1];
	}}
/>
<Text class="mb-s text-center" styleType="h2">
	{$format('choose_time')}
</Text>
<div class="text-center">
	<TimePickerWrapper bind:time={value.time} />
</div>
